// Email validation utilities

/**
 * Validate email format using regex
 * @param email Email address to validate
 * @returns True if email format is valid
 */
export function validateEmailFormat(email: string): boolean {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test(email);
}

/**
 * Check if email is from a disposable email provider
 * @param email Email address to check
 * @returns True if email is from a disposable provider
 */
export function isDisposableEmail(email: string): boolean {
	const disposableDomains = [
		"10minutemail.com",
		"guerrillamail.com",
		"mailinator.com",
		"temp-mail.org",
		"throwaway.email",
	];

	const domain = email.split("@")[1]?.toLowerCase();
	return domain ? disposableDomains.includes(domain) : false;
}

/**
 * Normalize email address for comparison
 * @param email Email address to normalize
 * @returns Normalized email address
 */
export function normalizeEmail(email: string): string {
	return email.toLowerCase().trim();
}
